import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { FacebookShareButton, LinkedinShareButton, TelegramShareButton } from 'react-share';
import { BrandFacebook, BrandLinkedin, BrandTelegram } from 'tabler-icons-react';
import OutsideHandler from 'components/common/OutsideHandler';
import Copy from 'components/elements/buttons/Copy';

import './ShareOptions.css';

const ShareOptions = ({
  copyText,
  className,
  btnText,
  copyBtnText,
  onCopy,
  noIcon,
  children,
}) => {

  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <Translation>
      {(t) => (
        <div className={`share-options-button-element__component ${className}`}>
          <div
            className="share-options-button-element-item"
            onClick={() => { setDropdownOpen(!dropdownOpen); }}
          >
            {!noIcon && !children &&
              <div className="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="56" height="50" viewBox="0 0 56 50"><path d="M33.128 41.786v-6.243h22.873v6.243H33.128zM46.934 8.2h9.067v6.243h-9.067V8.2zM30.758 22.645c-5.122 0-9.599-3.357-10.997-8.202H-.009V8.2h19.77c1.398-4.845 5.875-8.202 10.997-8.202 6.307 0 11.436 5.079 11.436 11.324 0 6.244-5.129 11.323-11.436 11.323zm0-16.405c-2.829 0-5.133 2.28-5.133 5.082 0 2.8 2.304 5.081 5.133 5.081 2.828 0 5.131-2.281 5.131-5.081 0-2.802-2.303-5.082-5.131-5.082zM16.95 27.339c6.307 0 11.437 5.08 11.437 11.326 0 6.245-5.13 11.323-11.437 11.323-5.12 0-9.599-3.356-10.997-8.202H-.009v-6.243h5.962c1.398-4.846 5.877-8.204 10.997-8.204zm0 16.407c2.829 0 5.132-2.281 5.132-5.081 0-2.802-2.303-5.082-5.132-5.082-2.829 0-5.132 2.28-5.132 5.082 0 2.8 2.303 5.081 5.132 5.081z" /></svg>
              </div>
            }
            {btnText && !children &&
              <div className="text">{btnText}</div>
            }
            {children}
          </div>

          {dropdownOpen &&
            <OutsideHandler handleClickOutside={() => { setDropdownOpen(false); }}>
              <div className="share-options-element-dropdown">

                <div className="action-item">
                  <FacebookShareButton url={copyText}>
                    <BrandFacebook />
                    <span>{t("Share on")} Facebook</span>
                  </FacebookShareButton>
                </div>
                <div className="action-item">
                  <LinkedinShareButton url={copyText}>
                    <BrandLinkedin />
                    <span>{t("Share on")} Linkedin</span>
                  </LinkedinShareButton>
                </div>
                <div className="action-item">
                  <TelegramShareButton url={copyText}>
                    <BrandTelegram />
                    <span>{t("Share on")} Telegram</span>
                  </TelegramShareButton>
                </div>

                <div className="share-element-footer" />

                <div className="action-item">
                  <button>
                    <Copy copyText={copyText} btnText={copyBtnText} onCopy={onCopy} />
                  </button>
                </div>
              </div>
            </OutsideHandler>
          }
        </div>
      )}
    </Translation>
  );
};
ShareOptions.propTypes = {
  copyText: PropTypes.string.isRequired,
  btnText: PropTypes.string,
  copyBtnText: PropTypes.string,
  onCopy: PropTypes.func,
  noIcon: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.object]),
};
ShareOptions.defaultProps = {
  btnText: 'Options',
  copyBtnText: 'Copy',
  onCopy: null,
  className: '',
  children: null,
};

export default ShareOptions;
